'use client';

import { useMemo, useRef, useState, useCallback, useEffect } from 'react';

//* HOC's
import { withUIContext } from '@/context';

//* Components
import Page from '@/components/global/Page';
import Text from '@/components/global/Text';
import Editor from '@/components/global/Editor';
import Container from '@/components/global/Container';

//* Style
import DataProtectionStyle from '@/styles/pages/DataProtectionStyle';

const DataProtectionTemplate = ({
	pageData: {
		data: { title, items },
	},
	winHeight,
}) => {
	//! State
	const [activeIndex, setActiveIndex] = useState(0);

	//! Ref
	const descriptionItems = useRef([]);

	//! Right bar
	const storeRightBarContent = useMemo(() => {
		return items.map((item, index) => {
			return (
				<div
					key={index}
					className='content-block'
					ref={(ref) => (descriptionItems.current[index] = ref)}>
					<Text className='h3 primary-color1 workSans-medium block-title'>{item.title}</Text>

					<Editor
						data={item.description}
						className='second-version'
					/>
				</div>
			);
		});
	}, [items]);

	//! Scroll effect
	useEffect(() => {
		window.addEventListener('scroll', scroll);

		return () => {
			window.removeEventListener('scroll', scroll);
		};
	}, []);

	//! Scroll
	const scroll = () => {
		let arr = [];

		for (let i = 0; i < descriptionItems.current.length; i++) {
			if (descriptionItems.current[i].getBoundingClientRect().top < winHeight * 0.3) {
				arr.push(i);
			}
		}

		if (arr.length === 0) {
			setActiveIndex(0);
		} else {
			setActiveIndex(arr.length - 1);
		}
	};

	//! Handle list link click
	const handleListLinkClick = useCallback(
		(clickedIndex) => {
			const headerHeight = document.querySelector('header').offsetHeight;

			let customHeaderSize = headerHeight + headerHeight / 2;

			window.scrollTo({
				top: window.pageYOffset + descriptionItems.current?.[clickedIndex].getBoundingClientRect().top - customHeaderSize,
				behavior: 'smooth',
			});
		},
		[descriptionItems]
	);

	//! Scroll effect
	useEffect(() => {
		window.addEventListener('scroll', scroll);

		return () => {
			window.removeEventListener('scroll', scroll);
		};
	}, []);

	//! Left bar
	const storeLeftBarItems = useMemo(() => {
		return items.map((item, index) => {
			return (
				<Text
					key={index}
					onClick={() => handleListLinkClick(index)}
					className={`p p1 workSans-medium title-clickable ${activeIndex === index ? 'active' : ''}`}
					text={item.title}
				/>
			);
		});
	}, [items, activeIndex]);

	return (
		<Page className='data-protection'>
			<DataProtectionStyle>
				<Container>
					<Text className={'h1 workSans-regular uppercase title'}>{title}</Text>

					<Container
						row
						full
						className='bars-wrap'>
						<div className='sticky-wrap col-3 col-ds-3 col-t-4 col-ts-12'>
							<div className='left-bar'>{storeLeftBarItems}</div>
						</div>

						<div className='right-bar col-7 col-ds-8 col-t-8 col-ts-12'>{storeRightBarContent}</div>

						<div className='col-2 col-ds-1 col-t-12 col-ts-12' />
					</Container>
				</Container>
			</DataProtectionStyle>
		</Page>
	);
};

export default withUIContext(DataProtectionTemplate, ['winHeight']);
